export default __webpack_public_path__ + "media/react/pages/sectioned_assignments/detail/pencil-c136cbdfb82512f7fddc38ca79761398.svg";